import { getListCurrency } from '../api/getListCurrency';
import { setGetListCurrencyAction } from '../action';

export const setGetListCurrency = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListCurrency(params);
            dispatch(setGetListCurrencyAction(data.data));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}